import { render, staticRenderFns } from "./VatMatrixSelector.vue?vue&type=template&id=594f8946&scoped=true&"
import script from "./VatMatrixSelector.vue?vue&type=script&lang=ts&"
export * from "./VatMatrixSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594f8946",
  null
  
)

export default component.exports